// VIBRANIAM-SPACE v2 - presets/index.js
// Built-in preset library. Each file in ./builtin/*.json is bundled at build
// time (eager glob, not a runtime fetch - avoids the public/ import dance
// wasm.js has to do for the same reason: Vite resolves these at build time,
// so they work identically in dev, in `npm run build`, and in the static web
// export). A preset file is validated the same way an imported patch is
// (parseGraphPayload), so a hand-edited builtin can never crash the app.

import { parseGraphPayload } from '../hooks/useModuleGraph.js';

const modules = import.meta.glob('./builtin/*.json', { eager: true });

function idFromPath(path) {
  return path.replace('./builtin/', '').replace(/\.json$/, '');
}

export const BUILTIN_PRESETS = Object.entries(modules)
  .map(([path, mod]) => {
    const raw = mod.default ?? mod;
    try {
      return {
        id: idFromPath(path),
        name: String(raw.name || idFromPath(path)),
        description: String(raw.description || ''),
        graph: parseGraphPayload(raw.graph),
        builtin: true,
      };
    } catch (err) {
      console.error(`[presets] "${path}" scartato: ${err.message}`);
      return null;
    }
  })
  .filter(Boolean)
  .sort((a, b) => a.name.localeCompare(b.name, 'it'));

export default BUILTIN_PRESETS;
